import { useCurrentUser } from 'services/repositories/user/user';
import { Page } from 'components/Page/Page';

type MetabaseDashboardProps = {
  dashboardUrl?: string | null;
};

export const Metabase = () => {
  const { data: currentUser } = useCurrentUser();

  return (
    <Page>
      <div className="flex flex-col items-center justify-center">
        <MetabaseDashboard dashboardUrl={currentUser?.partner?.metabase_dashboard_url} />
      </div>
    </Page>
  );
};

const MetabaseDashboard = ({ dashboardUrl }: MetabaseDashboardProps) => {
  if (!dashboardUrl) {
    return <div>No metabase dashboard url found</div>;
  }

  return <iframe src={dashboardUrl} style={{ width: '100%', height: '100vh' }} />;
};
